import { mediaData } from '@/mocks/homeData';

const imageUrls = [
  'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20palace%20scene%20with%20flowing%20silk%20costumes%20dramatic%20lighting%20cinematic%20composition%20rich%20warm%20tones%20golden%20hour%20atmosphere%20professional%20film%20still&width=600&height=400&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Dark%20moody%20cinema%20interior%20with%20red%20velvet%20seats%20mysterious%20spotlight%20on%20stage%20dramatic%20shadows%20noir%20atmosphere%20cinematic%20photography%20high%20contrast%20professional%20lighting&width=600&height=400&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vibrant%20summer%20outdoor%20cinema%20under%20stars%20with%20colorful%20string%20lights%20joyful%20crowd%20atmosphere%20warm%20golden%20hour%20lighting%20cinematic%20wide%20shot%20festival%20mood&width=600&height=400&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossoms%20falling%20soft%20pastel%20lighting%20intimate%20emotional%20moment%20cinematic%20shallow%20depth%20of%20field%20beautiful%20warm%20composition&width=600&height=400&seq=media-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20animation%20epic%20fantasy%20scene%20with%20mystical%20creatures%20floating%20mountains%20golden%20clouds%20dynamic%20lighting%20sweeping%20cinematic%20scale%20dramatic%20composition%20rich%20colors&width=600&height=400&seq=media-05&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          精选推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={imageUrls[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-white/20 backdrop-blur-sm text-background-50 text-[11px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-background-50 text-[11px] whitespace-nowrap">{item.views} 播放</span>
                  <div className="w-8 h-8 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-sm"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}